import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './TipoEmailSelector.module.css'

const TIPOS_EMAIL = [
  { label: 'Email seguimiento diario', value: 'DAILY' },
  { label: 'Email seguimiento leads', value: 'LEADS' }
]

const TipoEmailSelector = ({ className, name, label, value, onChange }) => (
  <FormControl
    className={`${className} ${css.main}`}
    variant='standard'
    margin='dense'
    fullWidth
  >
    <InputLabel id={name}>{label}</InputLabel>
    <Select
      name={name}
      labelId={name}
      id={name}
      value={value}
      onChange={onChange}
      label={label}
    >
      {TIPOS_EMAIL.map(tipo => (
        <MenuItem key={tipo.value} value={tipo.value}>
          {tipo.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default TipoEmailSelector
